export default __webpack_public_path__ + "27e18e756f64fd6d1021950768a58616.png";